import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export interface Testimonial {
  initials: string;
  name: string;
  location: string;
  text: string;
  color: string;
  pack?: string;
}
interface TestimonialsProps {
  testimonials: Testimonial[];
  title?: string;
  className?: string;
}
export function Testimonials({
  testimonials,
  title,
  className = ''
}: TestimonialsProps) {
  return <section className={`py-16 bg-zinc-900 ${className}`} data-id="element-291">
      <div className="container mx-auto px-4" data-id="element-292">
        {title && <h2 className="font-bold text-center mb-12 text-white text-[16px] md:text-2xl" data-id="element-293">
            {title}
          </h2>}

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-294">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-black/70 p-6 rounded-2xl shadow-lg border border-amber-900/40 flex flex-col h-full" data-id="element-295">
              <div className="flex items-center gap-1 mb-4" data-id="element-296">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 text-amber-400 fill-amber-400" data-id="element-297" />)}
              </div>

              <p className="text-zinc-100 italic mb-6 flex-grow" data-id="element-298">"{t.text}"</p>

              <div className="flex items-center gap-3 mt-auto pt-4 border-t border-amber-900/30" data-id="element-299">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center text-white font-bold text-sm ${t.color}`} data-id="element-300">
                  {t.initials}
                </div>
                <div data-id="element-301">
                  <p className="font-bold text-white text-sm" data-id="element-302">{t.name}</p>
                  <p className="text-xs text-amber-200" data-id="element-303">{t.location}</p>
                  {t.pack && <p className="text-xs font-medium text-amber-300 mt-0.5" data-id="element-304">
                      {t.pack}
                    </p>}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}
export const initialTestimonials: Testimonial[] = [{
  initials: 'MR',
  name: 'Martín R.',
  location: '🔧 Herrero independiente · Buenos Aires',
  text: 'Llevaba años soldando de oído, sin técnica ni sistema. Abrí el Módulo 1 y entendí por qué nunca había mejorado. No era que la herrería era difícil — era que nadie me la había enseñado paso a paso.',
  color: 'bg-amber-600'
}, {
  initials: 'LG',
  name: 'Lucas G.',
  location: '🔧 Tornero · Rosario',
  text: 'Fabriqué mi primera máquina de GYM siguiendo los planos y la vendí antes de terminarla. Nunca pensé que iba a poder hacerlo solo.',
  color: 'bg-amber-700'
}, {
  initials: 'FP',
  name: 'Federico P.',
  location: '🔧 Dueño de taller · Mendoza',
  text: 'Perdía clientes porque no sabía cómo cobrar ni cómo vender mis trabajos. Después del módulo de Rentabilidad tengo lista de espera.',
  color: 'bg-amber-800'
}];
export const moreTestimonials: Testimonial[] = [{
  initials: 'JM',
  name: 'Julián M.',
  location: '🏙️ Buenos Aires',
  text: 'Dos años mirando videos sueltos de YouTube sin avanzar. Con el sistema de este Megapack en tres semanas fabriqué mi primera reja artística y la vendí al doble de lo que cobraba antes.',
  color: 'bg-amber-700',
  pack: 'Megapack Herrero Argentino'
}, {
  initials: 'DS',
  name: 'Diego S.',
  location: '🏙️ Santa Fe',
  text: 'El módulo de Rentabilidad me hizo dar cuenta que estaba regalando mi trabajo. Subí los precios un 40% y no perdí ningún cliente.',
  color: 'bg-amber-800',
  pack: 'Megapack + Nivel Maestro'
}, {
  initials: 'CP',
  name: 'Carlos P.',
  location: '🏙️ Tucumán',
  text: 'Con el Nivel Maestro fabriqué mi primer trailer. Lo vendí antes de terminarlo. Ahora tengo 3 encargados en lista de espera.',
  color: 'bg-amber-600',
  pack: 'Megapack + Nivel Maestro'
}, {
  initials: 'MG',
  name: 'Miguel G.',
  location: '🏙️ Rosario',
  text: 'Cerré 4 trabajos nuevos el mes pasado usando las técnicas de ventas. Antes los perdía por no saber cómo presentar el presupuesto.',
  color: 'bg-amber-900',
  pack: 'Megapack + Nivel Maestro'
}, {
  initials: 'MV',
  name: 'Marcos V.',
  location: '🏙️ Córdoba',
  text: 'Empecé desde cero con el Módulo 1. Hoy tengo mi propio taller y lista de espera de clientes. En un año cambió todo.',
  color: 'bg-amber-700',
  pack: 'Megapack Herrero Argentino'
}];